import { Hero } from "@/components/site/Hero";
import { ChristmasTree } from "@/components/site/ChristmasTree";
import { MatchingSection } from "@/components/site/MatchingSection";
import { HowItWorks, BigGifts } from "@/components/site/Sections";
import { NewsletterForm } from "@/components/site/NewsletterForm";
import { DecorAccent } from "@/components/site/AssetImage";
import { GiftSection } from "@/components/site/GiftSection";

function NewsletterSection() {
  return (
    <section aria-labelledby="newsletter-heading" className="of-container py-16 sm:py-20" data-testid="home-newsletter-section">
      <div className="of-card grid gap-8 p-6 sm:p-10 md:grid-cols-[1fr_1.1fr] md:items-center">
        <div className="flex items-start gap-5">
          <DecorAccent asset="ELF" className="hidden sm:flex" />
          <div>
            <p className="of-eyebrow">Newsletter</p>
            <h2 id="newsletter-heading" className="mt-3 text-3xl font-semibold">Hear how the drive went.</h2>
            <p className="mt-3 text-lg text-[#3B4A44]">One or two emails a year. That's it.</p>
          </div>
        </div>
        <NewsletterForm idPrefix="home" />
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <main id="main" data-testid="home-page">
      <Hero />
      <ChristmasTree />
      <GiftSection />
      <MatchingSection />
      <HowItWorks />
      <NewsletterSection />
      <BigGifts />
    </main>
  );
}
